export default "__VITE_ASSET__CLmSAWW7__"